import { createBrowserRouter } from 'react-router';
import { AppShell } from '../components/AppShell.js';
import { AuthCallbackPage } from '../features/auth/AuthCallbackPage.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { RequireAuth } from '../features/auth/RequireAuth.js';
import { BudgetPage } from '../routes/BudgetPage.js';
import { DashboardPage } from '../routes/DashboardPage.js';
import { ImportPage } from '../routes/ImportPage.js';
import { InvestmentDayPage } from '../routes/InvestmentDayPage.js';
import { NotFoundPage } from '../routes/NotFoundPage.js';
import { PortfolioPage } from '../routes/PortfolioPage.js';
import { SettingsPage } from '../routes/SettingsPage.js';
import { SpendingPage } from '../routes/SpendingPage.js';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'portfolio', element: <PortfolioPage /> },
      { path: 'import', element: <ImportPage /> },
      { path: 'spending', element: <SpendingPage /> },
      { path: 'budget', element: <BudgetPage /> },
      { path: 'investment-day', element: <InvestmentDayPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
